import React, { Component } from 'react';
import { Wrapper } from './style';
import { formatMessage } from '../../CurrentLocale';
import { connect } from 'react-redux';
import SearchLogo from '../../assets/images/logo.svg';
import LanguageSolid from '../../assets/images/language-solid.svg';
import ArrowDown from '../../assets/images/caret-down-solid-full.svg';
import BarsSolid from '../../assets/images/bars-solid-full.svg';
import Facebook from '../../assets/images/facebook-brands-solid-full.svg';
import Bluesky from '../../assets/images/bluesky-brands-solid-full.svg';
import LinkedIn from '../../assets/images/linkedin-brands-solid-full.svg';

type Props = {
  lang: string
};

class Header extends Component<Props, State> {
  state = {
    languageDropdownOpen: false,
    isScrolled: false
  };

  params = new URLSearchParams(window.location.search);

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleLang = () => {
    const { lang } = this.props;
    this.params.set('l', lang === 'en' ? 'fr' : 'en');

    localStorage.setItem('i18nextLng', lang === 'en' ? 'fr' : 'en');

    window.location.href = `${
      window.location.pathname
    }?${this.params.toString()}`;
  };

  handleScroll = () => {
    const isScrolled = window.scrollY > 140;

    if (isScrolled !== this.state.isScrolled) {
      this.setState({ isScrolled });
    }
  };

  render() {
    const { organizations } = this.props;

    return (
      <Wrapper>
        <header
          className={`openbarre ${
            !this.state.isScrolled ? 'openbarre--extended' : ''
          }`}
          role="banner"
        >
          <div
            className={`openbarre__left ${
              this.state.isScrolled ? 'openbarre__left--scrolled' : ''
            }`}
          >
            <a
              className="openbarre__left__logo"
              href="/"
              title={formatMessage({ id: 'header.homepage' })}
            >
              <img
                className="openbarre__left__logo__img"
                src={SearchLogo}
                alt="OpenEdition Search logo"
              />
            </a>
            <ul className="openbarre__left__nav">
              <li className="openbarre__left__nav__item">
                <a
                  className="openbarre__left__nav__item__link"
                  href="https://documentation-openedition-org.ezscd.univ-lyon3.fr/docs/search-openedition/"
                  title={formatMessage({ id: 'header.help' })}
                >
                  {formatMessage({ id: 'header.help' })}
                </a>
              </li>
            </ul>
          </div>
          <div
            className={`openbarre__right ${
              this.state.isScrolled ? 'openbarre__right--scrolled' : ''
            }`}
          >
            <div
              className={`openbarre__right__top ${
                this.state.isScrolled ? 'openbarre__right__top--scrolled' : ''
              }`}
            >
              {organizations &&
                organizations.data &&
                organizations.data.length > 0 && (
                  <a
                    className={`openbarre__right__top__organization ${
                      this.state.isScrolled
                        ? 'openbarre__right__top__organization--scrolled'
                        : ''
                    }`}
                    href={organizations.data[0].logoUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={organizations.data[0].longname}
                  >
                    <div className="openbarre__right__top__organization__icon">
                      <img
                        className="openbarre__right__top__organization__icon__img"
                        src={organizations.data[0].logoUrl}
                        alt={organizations.data[0].longname}
                      />
                    </div>
                    <p className="openbarre__right__top__organization__name">
                      {organizations.data[0].longname}
                    </p>
                  </a>
                )}
              <div className="openbarre__right__top__language">
                <div className="openbarre__right__top__language__button">
                  <img
                    className="openbarre__right__top__language__button__icon"
                    src={LanguageSolid}
                    alt={formatMessage({ id: 'header.change_language' })}
                  />
                  <p className="openbarre__right__top__language__button__name">
                    {this.props.lang === 'en' ? 'English' : 'Français'}
                  </p>
                </div>
                <ul
                  className={`openbarre__right__top__language__dropdown ${
                    this.state.languageDropdownOpen ? 'visible' : ''
                  }`}
                >
                  <li className="openbarre__right__top__language__dropdown__item">
                    <a
                      className="openbarre__right__top__language__dropdown__item__link"
                      href="#"
                      onClick={e => {
                        e.preventDefault();
                        this.handleLang();
                      }}
                      title={this.props.lang === 'en' ? 'Français' : 'English'}
                    >
                      {this.props.lang === 'en' ? 'Français' : 'English'}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="openbarre__right__bottom">
              <div className="openbarre__right__bottom__button">
                <p className="openbarre__right__top__language__button__name">
                  {formatMessage({ id: 'header.all_openedition' })}
                </p>
                <img
                  className="openbarre__right__top__language__button__icon"
                  src={BarsSolid}
                  alt="OpenEdition menu"
                />
              </div>
              <div className="openbarre__right__bottom__menu">
                {organizations &&
                  organizations.data &&
                  organizations.data.length > 0 && (
                    <ul
                      className={`openbarre__right__bottom__menu__list openbarre__right__bottom__menu__list--organization ${
                        this.state.isScrolled
                          ? 'openbarre__right__bottom__menu__list--organization--scrolled'
                          : ''
                      }`}
                    >
                      <li className="openbarre__right__bottom__menu__list__item">
                        <a
                          className="openbarre__right__bottom__menu__list__item__link"
                          href={organizations.data[0].logoUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          title={organizations.data[0].longname}
                        >
                          <div className="openbarre__right__top__organization__icon">
                            <img
                              className="openbarre__right__top__organization__icon__img"
                              src={organizations.data[0].logoUrl}
                              alt={organizations.data[0].longname}
                            />
                          </div>
                          {organizations.data[0].longname}
                        </a>
                      </li>
                    </ul>
                  )}
                <h2 className="openbarre__right__bottom__menu__title">
                  {formatMessage({ id: 'header.digital_resources' })}
                </h2>
                <ul className="openbarre__right__bottom__menu__list">
                  <li className="openbarre__right__bottom__menu__list__item">
                    <a
                      className="openbarre__right__bottom__menu__list__item__link"
                      href="https://openedition-org.ezscd.univ-lyon3.fr/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="OpenEdition"
                    >
                      OpenEdition
                    </a>
                  </li>
                </ul>
                <h2 className="openbarre__right__bottom__menu__title">
                  {formatMessage({ id: 'header.our_platforms' })}
                </h2>
                <ul className="openbarre__right__bottom__menu__list">
                  <li className="openbarre__right__bottom__menu__list__item">
                    <a
                      className="openbarre__right__bottom__menu__list__item__link"
                      href="https://books-openedition-org.ezscd.univ-lyon3.fr/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="OpenEdition Books"
                    >
                      OpenEdition Books
                    </a>
                  </li>
                  <li className="openbarre__right__bottom__menu__list__item">
                    <a
                      className="openbarre__right__bottom__menu__list__item__link"
                      href="https://journals-openedition-org.ezscd.univ-lyon3.fr/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="OpenEdition Journals"
                    >
                      OpenEdition Journals
                    </a>
                  </li>
                  <li className="openbarre__right__bottom__menu__list__item">
                    <a
                      className="openbarre__right__bottom__menu__list__item__link"
                      href="https://hypotheses.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Hypotheses"
                    >
                      Hypotheses
                    </a>
                  </li>
                  <li className="openbarre__right__bottom__menu__list__item">
                    <a
                      className="openbarre__right__bottom__menu__list__item__link"
                      href="https://calenda.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Calenda"
                    >
                      Calenda
                    </a>
                  </li>
                </ul>
                <h2 className="openbarre__right__bottom__menu__title">
                  {formatMessage({ id: 'header.libraries' })}
                </h2>
                <ul className="openbarre__right__bottom__menu__list">
                  <li className="openbarre__right__bottom__menu__list__item">
                    <a
                      className="openbarre__right__bottom__menu__list__item__link"
                      href="https://www-openedition-org.ezscd.univ-lyon3.fr/14043"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="OpenEdition Freemium"
                    >
                      OpenEdition Freemium
                    </a>
                  </li>
                </ul>
                <h2 className="openbarre__right__bottom__menu__title">
                  {formatMessage({ id: 'header.follow_us' })}
                </h2>
                <ul className="openbarre__right__bottom__menu__icons">
                  <li className="openbarre__right__bottom__menu__icons__item">
                    <a
                      className="openbarre__right__bottom__menu__icons__item__link"
                      href="https://www.facebook.com/openedition"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Facebook"
                    >
                      <img
                        className="openbarre__right__top__language__button__icon"
                        src={Facebook}
                        alt="OpenEdition Facebook"
                      />
                    </a>
                  </li>
                  <li className="openbarre__right__bottom__menu__icons__item">
                    <a
                      className="openbarre__right__bottom__menu__icons__item__link"
                      href="https://bsky.app/profile/openedition.bsky.social"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Bluesky"
                    >
                      <img
                        className="openbarre__right__top__language__button__icon"
                        src={Bluesky}
                        alt="OpenEdition Bluesky"
                      />
                    </a>
                  </li>
                  <li className="openbarre__right__bottom__menu__icons__item">
                    <a
                      className="openbarre__right__bottom__menu__icons__item__link"
                      href="https://fr.linkedin.com/company/cleo-centre-pour-l%27%E2%80%8B-dition-lectronique-ouverte-"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="LinkedIn"
                    >
                      <img
                        className="openbarre__right__top__language__button__icon"
                        src={LinkedIn}
                        alt="OpenEdition LinkedIn"
                      />
                    </a>
                  </li>
                </ul>
                <ul className="openbarre__right__bottom__menu__list">
                  <li className="openbarre__right__bottom__menu__list__item">
                    <a
                      className="openbarre__right__bottom__menu__list__item__link"
                      href="https://www-openedition-org.ezscd.univ-lyon3.fr/41045"
                      title="Newsletter"
                    >
                      Newsletter
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </header>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  organizations: state.organizations,
  lang: state.ui.lang
});

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js